import React from 'react';
import UsersTable from '../components/UsersTable';

const IncompleteUsers = ({ users, setUsers }) => (
  <div>
    <h1 className='title-page'>Incomplete Users</h1>
    <UsersTable users={users} setUsers={setUsers} />
  </div>
);

export default IncompleteUsers;
